import { useState, useEffect } from "react";
import Axios from "axios";
import { getAllData, InsertData } from "../utils/FormatLoadTrip";
import { useDispatch } from 'react-redux';
import { updateStateArrivalDepature } from '../redux/actions/refreshArrivalDepature/refreshArrivalDepatureAction';
import DB from "../db";
import config from "../config";

const useFetch = (url, setNotificacionesVistas, setMultipleSessionDialog) => {
  const [isloading, setIsLoading] = useState(false);
  const [todayData, setTodayData] = useState(null);
  const [yesterdayData, setYesterdayData] = useState(null);
  const [tomorrowData, setTomorrowData] = useState(null);
  const [badge, setBadge] = useState({
    today_badge: 0,
    tomorrow_badge: 0,
    yesterday_badge: 0,
  });
  const [error, setError] = useState(null);
  const [notificaciones, setNotificaciones] = useState(null);
  const [response, setResponse] = useState(null);
  const [directNotifications, setDirectNotifications] = useState(null);
  const [arrivalUpdateStatus, setArrivalUpdateStatus] = useState(false);
  const db = new DB();
  const dispatch = useDispatch();

  const doFetch = async () => {
    if (navigator.onLine) {
      setIsLoading(true);
      try {
        var token = localStorage.getItem("token");

        var response = await Axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Abp.Tenantid": config.TENANT_ID
          },
        });

        InsertData(
          response.data,
          setNotificacionesVistas,
          setYesterdayData,
          setTodayData,
          setTomorrowData,
          setNotificaciones,
          setBadge
        )
        setIsLoading(false);
      } catch (error) {
        setMultipleSessionDialog(true);
      }


    } else {
      setError(
        "No estas conectado a la red, la informacion que estas viendo es una copia vieja"
      );
      const allData = await db.getAll();

      const {
        yesterdayDataC,
        todayDataC,
        tomorrowDataC,
      } = getAllData(allData);
      setYesterdayData(yesterdayDataC);
      setTodayData(todayDataC);
      setTomorrowData(tomorrowDataC);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    doFetch();
  }, [url]);

  useEffect(() => {
    if (arrivalUpdateStatus) {
      dispatch(updateStateArrivalDepature())
      setArrivalUpdateStatus(false);
    }
  }, [arrivalUpdateStatus])

  return {
    isloading,
    yesterdayData,
    todayData,
    tomorrowData,
    error,
    badge,
    doFetch: doFetch,
    notificaciones,
    response,
    directNotifications
  };
};

export default useFetch;
